import { useQuery } from "@tanstack/react-query";
import { FEATURE_FLAG_FALLBACK, type FeatureFlags } from "@atlas/shared";
import { fetchFeatureFlags } from "../api/flags";

export const FEATURE_FLAGS_KEY = ["flags"];

/** Server-driven feature flags (admin > Flags). Until the request resolves,
 *  and if it fails, the fallback applies - which gates everything, so a page
 *  never briefly shows a button that would dead-end. */
export function useFeatureFlags(): FeatureFlags {
  const { data } = useQuery({
    queryKey: FEATURE_FLAGS_KEY,
    queryFn: fetchFeatureFlags,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
  return data?.flags ?? FEATURE_FLAG_FALLBACK;
}

export function useStravaConnectionsFull(): boolean {
  return useFeatureFlags().stravaConnectionsFull;
}

/** Beta gate: while on, Stripe entry points open the beta-access modal. Falls
 *  back to gated until GET /flags answers, so a checkout button never shows
 *  briefly before the server would refuse it. */
export function useBetaGate(): boolean {
  return useFeatureFlags().betaGate;
}
